<template>
  <p :class="style({ disabled })">
    <slot />
  </p>
</template>

<script lang="ts" setup>
import { tv } from 'tailwind-variants';

interface Props {
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
});

const style = tv({
  base: 'text-sm tracking-[1px] text-black1 md:text-base',
  variants: {
    disabled: { true: 'text-gray2' },
  },
});
</script>
